module.exports = __webpack_public_path__ + "static/media/logo-text-handritin-til-barnanna-brown.313bd7f3.svg";